import { Component, OnInit } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  ContaReceberLoteService,
  ContaReceberLotePrevia,
  ContaReceberLoteRequest,
} from 'src/app/service/conta-receber-lote.service';
import { SegmentoService } from 'src/app/service/segmento.service';
import { ContaCorrenteService } from 'src/app/service/contaCorrente.service';
import { Segmento } from '../segmento/segmento';
import { ContaCorrente } from '../conta-corrente/contacorrente';

@Component({
  selector: 'app-conta-receber-lote',
  templateUrl: './conta-receber-lote.component.html',
  styleUrls: ['./conta-receber-lote.component.scss'],
})
export class ContaReceberLoteComponent implements OnInit {

  segmentos: Segmento[] = [];
  contasCorrentes: ContaCorrente[] = [];

  segmentoId: number | null = null;
  competencia: string = this.competenciaAtual();
  dataCompetencia: Date = new Date();
  formaCobranca = 'MANUAL';
  contaCorrenteId: number | null = null;
  descricao = 'Cobrança {plano} - período {periodo}';
  observacao = '';

  previa: ContaReceberLotePrevia[] = [];
  selecionados = new Set<number>();
  expandido = new Set<number>();

  carregando = false;
  gerando = false;
  consultou = false;

  constructor(
    private contaReceberLoteService: ContaReceberLoteService,
    private segmentoService: SegmentoService,
    private contaCorrenteService: ContaCorrenteService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.segmentoService.listarAtivos().subscribe(lista => (this.segmentos = lista));
    this.contaCorrenteService.listar().subscribe(lista => (this.contasCorrentes = lista));
  }

  buscar(): void {
    if (!this.competencia) {
      this.snackBar.open('Informe a competência (mês/ano).', 'OK', { duration: 2500 });
      return;
    }
    this.carregando = true;
    this.consultou = true;
    this.selecionados.clear();
    this.expandido.clear();
    this.contaReceberLoteService.previa(this.segmentoId, this.competencia).subscribe(lista => {
      this.previa = lista || [];
      this.previa.forEach(p => this.selecionados.add(p.clienteId));
      this.carregando = false;
    }, () => {
      this.previa = [];
      this.carregando = false;
      this.snackBar.open('Erro ao buscar clientes.', 'ERRO', { duration: 2500 });
    });
  }

  alternarSelecao(id: number): void {
    if (this.selecionados.has(id)) {
      this.selecionados.delete(id);
    } else {
      this.selecionados.add(id);
    }
  }

  alternarTodos(marcar: boolean): void {
    this.selecionados.clear();
    if (marcar) {
      this.previa.forEach(p => this.selecionados.add(p.clienteId));
    }
  }

  todosMarcados(): boolean {
    return this.previa.length > 0 && this.selecionados.size === this.previa.length;
  }

  alternarDetalhe(id: number): void {
    if (this.expandido.has(id)) {
      this.expandido.delete(id);
    } else {
      this.expandido.add(id);
    }
  }

  get totalSelecionado(): number {
    return this.previa
      .filter(p => this.selecionados.has(p.clienteId))
      .reduce((acc, p) => acc + (p.valorTotal || 0), 0);
  }

  gerar(): void {
    if (this.selecionados.size === 0) {
      this.snackBar.open('Selecione ao menos um cliente.', 'OK', { duration: 2500 });
      return;
    }
    if (!this.competencia) {
      this.snackBar.open('Informe a competência (mês/ano).', 'OK', { duration: 2500 });
      return;
    }
    if (this.formaCobranca !== 'MANUAL' && !this.contaCorrenteId) {
      this.snackBar.open('Selecione a conta corrente para emitir a cobrança.', 'OK', { duration: 3000 });
      return;
    }

    const request: ContaReceberLoteRequest = {
      segmentoId: this.segmentoId,
      competencia: this.competencia,
      formaCobranca: this.formaCobranca,
      contaCorrenteId: this.formaCobranca === 'MANUAL' ? null : this.contaCorrenteId,
      descricao: this.descricao,
      observacao: this.observacao,
      clienteIds: Array.from(this.selecionados),
    };

    this.gerando = true;
    this.contaReceberLoteService.gerar(request).subscribe(res => {
      this.gerando = false;
      this.snackBar.open(`Geradas: ${res.gerados} | Erros: ${res.erros}`, 'OK', { duration: 5000 });
      this.buscar();
    }, () => {
      this.gerando = false;
      this.snackBar.open('Erro ao gerar cobranças.', 'ERRO', { duration: 3000 });
    });
  }

  labelContaCorrente(c: ContaCorrente): string {
    return c.banco ? `${c.descricao} — ${c.banco}` : c.descricao;
  }

  private competenciaAtual(): string {
    const hoje = new Date();
    const mes = String(hoje.getMonth() + 1).padStart(2, '0');
    return `${hoje.getFullYear()}-${mes}`;
  }

  onCompetenciaChange(): void {
    if (!this.dataCompetencia) {
      return;
    }
    const ano = this.dataCompetencia.getFullYear();
    const mes = String(this.dataCompetencia.getMonth() + 1).padStart(2, '0');
    this.competencia = `${ano}-${mes}`;
  }

  onMesSelecionado(data: Date, picker: MatDatepicker<Date>): void {
    this.dataCompetencia = new Date(data.getFullYear(), data.getMonth(), 1);
    this.onCompetenciaChange();
    picker.close();
  }

  get competenciaLabel(): string {
    if (!this.competencia) {
      return '';
    }
    const [ano, mes] = this.competencia.split('-');
    const nomes = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
      'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
    const indice = Number(mes) - 1;
    const nomeMes = nomes[indice] || mes;
    return `${nomeMes}/${ano}`;
  }
}
